import React from 'react'
import { AsyncSelect } from './AsyncSelect'
import { baseUrl } from 'utils/axios'
import { Option } from './Select'

export const InventorySupplierSelect = ({
  onChange,
  value,
  width,
  label,
  placeholder,
  error,
}: {
  onChange: (value: Option) => void
  value?: Option | null
  width?: string
  label?: string
  placeholder?: string
  error?: string
}) => {
  return (
    <AsyncSelect<{ id: number; name: string }>
      width={width}
      label={label}
      optionKey='inventory-suppliers'
      placeholder={placeholder || 'All Suppliers'}
      nullValue={placeholder ? undefined : { label: 'All Suppliers', value: null }}
      loadOptions={async (search) => {
        const data = await baseUrl.get('/inventory-suppliers', {
          params: {
            q: search,
            page: 1,
            limit: 20,
          },
        })
        return data.data.data.map((item) => ({
          id: item.id,
          name: item.name,
        })) as { id: number; name: string }[]
      }}
      decoder={(item) => ({
        label: item.name,
        value: item.id,
      })}
      onChange={(value) => onChange(value)}
      value={value}
      error={error}
    />
  )
}
